import { queryOptions, useQuery } from "@tanstack/react-query";

export type TechStackItem = {
  name: string;
  count: number;
};

export type MergedCompany = {
  id: string;
  orgCompanyId: string;
  name: string;
  website: string;
  description: string;
  industry: string;
  size: string;
  knownLocations: string[];
  logoId?: string;
  relationshipStatus: string;
  leadCount: number;
  connectionCount: number;
  techStack: TechStackItem[];
  connectionProfileIds: string[];
  activeContractCount: number;
  totalContractCount: number;
};

const fetchCompanies = async (
  organizationID: string,
): Promise<MergedCompany[]> => {
  const token = localStorage.getItem("profiletool-auth-token");
  const baseUrl =
    process.env.REACT_APP_BASE_URL ?? "https://profiletool-api.onrender.com";

  const response = await fetch(
    `${baseUrl}/v1/organizations/${organizationID}/companies`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  if (!response.ok) throw new Error("Failed to fetch companies");
  return response.json();
};

export const getCompaniesOptions = (organizationID: string) =>
  queryOptions({
    queryKey: ["companies", organizationID],
    queryFn: () => fetchCompanies(organizationID),
    staleTime: 1000 * 60 * 5,
  });

export const useGetCompanies = (organizationID: string) =>
  useQuery(getCompaniesOptions(organizationID));
